import { __rest } from "tslib";
import React from 'react';
import cn from 'classnames';
import styles from './Container.module.scss';
const Container = (_a) => {
    var { Tag = 'div', children, className, withoutPaddingBottom, large, xlarge, fullWidth } = _a, props = __rest(_a, ["Tag", "children", "className", "withoutPaddingBottom", "large", "xlarge", "fullWidth"]);
    return (React.createElement(Tag, Object.assign({ className: cn(styles.container, className, large && styles.large, xlarge && styles.xlarge, withoutPaddingBottom && styles.withoutPaddingBottom, fullWidth && styles.fullWidth) }, props), children));
};
export default Container;
//# sourceMappingURL=Container.js.map